import React, { useEffect, useState } from 'react';

import { verifyEmail } from '../services/auth';

import { useNavigate } from 'react-router-dom';

import { Spinner } from 'react-bootstrap';

import { getUrlParamValue } from '../utils/data';
import Button from '../components/Button';
import i18n from '../utils/i18n';

const VerifyAccount = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [titleMessage, setTitleMessage] = useState('');

  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const verifyAccount = async () => {
      try {
        setLoading(true);
        setTitleMessage('Verificando sua conta');

        const token = getUrlParamValue('token');

        if (token) {
          await verifyEmail(token);

          setTitleMessage('Conta verificada!');
          return;
        }
        setTitleMessage('Ops!');
        setErrorMessage('Ocorreu um erro ao verificar o e-mail.');
      } catch (error) {
        setTitleMessage('Ops!');
        setErrorMessage('Ocorreu um erro ao verificar o e-mail.');
      } finally {
        setLoading(false);
      }
    };
    verifyAccount();
  }, []);

  return (
    <>
      <div className="login-container">
        <div className="container-fluid h-100">
          <div className="row h-100 align-items-center justify-content-center">
            <div className="col-12 col-md-8 col-lg-6 col-xl-5">
              <div className="login-card">
                <div className="login-logo-container">
                  <img
                    src="assets/images/logo-only.png"
                    className="login-logo"
                    alt="Silk Secret"
                  />
                  <h1 className="login-brand-name">silk secret</h1>
                </div>

                <h2 className="login-title">{i18n.t<string>('Login.title')}</h2>
                <div className="card-body rounded-0 text-center">
                  <h2 className="fw-700 font-md font-xs mb-5">
                    {titleMessage}
                  </h2>
                  {loading ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="text-warning"
                      />
                    </div>
                  ) : (
                    <div className="col-sm-12 p-0 text-center">
                      {errorMessage.length ? (
                        <>
                          <span className="text-grey-900 font-xs fw-500">
                            {errorMessage}
                          </span>
                          <Button onClick={() => navigate('/login')} className='mt-5'>
                            Voltar
                          </Button>
                        </>
                      ) : (
                        <Button onClick={() => navigate('/login')}>
                          Entrar
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyAccount;
